import type { RedcatAnalyticsStore } from '../types/store';
import { SignupTrackEventName } from '../types/signup';
import type { SignupTrackEvent } from '../types/events/track';

// Fields with their own dedicated tracking event skip the generic field-completed
// event, so toggling them doesn't fire two events for the one interaction.
const FIELDS_WITH_DEDICATED_TRACKING = ['sendemail', 'sendsms'];

export const trackSignupFieldCompleted = (
  track: RedcatAnalyticsStore['track'],
  {
    fieldName,
    fieldIndex,
    inputType,
    isRequired,
    isValid,
    startTime,
  }: {
    fieldName: string;
    fieldIndex: number | undefined;
    inputType?: string;
    isRequired: boolean;
    isValid: boolean;
    startTime: number | null;
  },
) => {
  if (fieldIndex == null || startTime == null) return;
  if (inputType && FIELDS_WITH_DEDICATED_TRACKING.includes(inputType)) return;

  const event: SignupTrackEvent = {
    name: SignupTrackEventName.FieldCompleted,
    properties: {
      field_name: fieldName,
      field_index: fieldIndex,
      is_required: isRequired,
      is_valid: isValid,
      time_on_field_sec: Number(((Date.now() - startTime) / 1000).toFixed(1)),
    },
  };

  track(event);
};
